export function stringifyBoolean(value: unknown) {
  return value ? "true" : "false";
}

export function parseBoolean(value: string) {
  const normalized = value.trim().toLowerCase();
  if (!normalized) {
    return false;
  }
  if (normalized === "true") {
    return true;
  }
  if (normalized === "false") {
    return false;
  }
  throw new Error(`Invalid boolean value "${value}"`);
}
